module.exports = "/_next/static/images/d4d65227e1cfdd5e59ea1eb3a48cfa37-roxinho-single-xs@1x.jpg";